import type { ChangeEvent } from 'react';

export const validateInput = (
  rules: { [key: string]: string | number | boolean },
  value: string | number | boolean | string[] | ChangeEvent<HTMLInputElement> | undefined | null | FileList
) => {
  const validationResponse = { isValid: true, error: '' };

  if (typeof value === 'undefined' || value === null) {
    if (rules.required) {
      return { isValid: false, error: 'Required' };
    }
  }

  if (typeof value === 'string') {
    if (rules.type !== typeof value) {
      return { isValid: false, error: 'Invalid value type' };
    }
    if (rules.required && value.trim() === '') {
      return { isValid: false, error: 'Required' };
    }
    if (value.length < (rules.minLength as number)) {
      return {
        isValid: false,
        error: `Must be greater than ${rules.minLength} characters.`,
      };
    }
    if (value.length > (rules.maxLength as number)) {
      return {
        isValid: false,
        error: `Must be less than or equal to ${rules.maxLength} characters.`,
      };
    }
  }

  if (typeof value === 'number') {
    if (value > (rules.max as number)) {
      return {
        isValid: false,
        error: `Must be less than or equal to ${rules.max}`,
      };
    }
    if (value < (rules.min as number)) {
      return {
        isValid: false,
        error: `Must be greater than ${rules.min}`,
      };
    }
    if (rules.isInteger && !Number.isInteger(value)) {
      return {
        isValid: false,
        error: 'Must be a integer number.',
      };
    }
    if (value.toString().length < (rules.minLength as number)) {
      return {
        isValid: false,
        error: `Must be greater than ${rules.minLength} characters.`,
      };
    }
    if (value.toString().length > (rules.maxLength as number)) {
      return {
        isValid: false,
        error: `Must be less than or equal to ${rules.maxLength} characters.`,
      };
    }
  }

  if (typeof value === 'boolean') {
    return validationResponse;
  }

  if (typeof value === 'object' && Array.isArray(value)) {
    if (value.length < (rules.minLength as number) && rules.required) {
      return { isValid: false, error: 'Required' };
    }
  }

  // Handle FileList (for file inputs)
  if (value instanceof FileList) {
    if (rules.required && value.length === 0) {
      return { isValid: false, error: 'Required' };
    }
  }

  // Handle ChangeEvent (extract value from event if needed)
  if (value && typeof value === 'object' && 'target' in value) {
    const event = value as ChangeEvent<HTMLInputElement>;
    if (event.target.type === 'file' && event.target.files) {
      if (rules.required && event.target.files.length === 0) {
        return { isValid: false, error: 'Required' };
      }
    }
  }

  return validationResponse;
};
